module.exports = __webpack_public_path__ + "img/sii-mini.3f3102d5.svg";